import React from 'react';

import cyclist from '../../images/cyclist.png';
import './Metrics.scss';

const Metrics = () => (
  <div className="metrics container">
    <div className="flex col col-8">
      <div className="col col-6">
        <h1 className="display">
          20<span>%</span>
        </h1>
        <div className="info-text">
          <span className="text">Extra time generated </span>
          within your working hours.
        </div>
      </div>
      <div className="col col-6">
        <h1 className="display">
          60<span>%</span>
        </h1>
        <div className="info-text">
          <span className="text">More work done per week </span>
          due to better prioritization
        </div>
      </div>
    </div>
    <div className="col col-4 flex justify-flex-end">
      <img className="cyclist" src={cyclist} alt="" />
    </div>
  </div>
);

export default Metrics;
